<template>
  <div class="content">
    <div class="title-container">
      <router-link :to="link">
        <div class="title">{{ title }}</div>
      </router-link>
    </div>
    <div class="navigation-container">
      <div class="flashing-pointer-container">
        <div
          class="flashing-pointer-1"
          :style="{ background: bgPointer1 }"
        ></div>
        <div
          class="flashing-pointer-2"
          :style="{ background: bgPointer2 }"
        ></div>
      </div>
      <div id="progressBar" class="progress" :style="{ width: progress }"></div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from "vue";
import RotatingItems from "@/components/RotatingItems.vue";

export default defineComponent({
  props: {},
  components: {
    // RotatingItems
  },
  setup() {
    const title = ref("Personal Activity");
    const link = ref("personal-activity");
    const progress = ref("0%");
    const bgPointer1 = ref("#adb5bd");
    const bgPointer2 = ref("#adb5bd");

    window.addEventListener("scroll", () => {
      const scrollMaxAmount = document.documentElement.clientHeight * 2; // net scroll ammount
      const progressRate = (window.pageYOffset / scrollMaxAmount) * 100;
      progress.value = `${progressRate}%`;
      if (window.pageYOffset / scrollMaxAmount < 1 / 3) {
        title.value = "Personal Activity";
        link.value = "personal-activity"
        bgPointer1.value = "#adb5bd";
      } else if (
        window.pageYOffset / scrollMaxAmount >= 1 / 3 &&
        window.pageYOffset / scrollMaxAmount < 2 / 3
      ) {
        title.value = "Works";
        link.value = "works"
        bgPointer1.value = "#2c3e50";
        bgPointer2.value = "#adb5bd";
      } else {
        title.value = "About Me";
        link.value = "about"
        bgPointer1.value = "#2c3e50";
        bgPointer2.value = "#2c3e50";
      }
    });

    return { title, link, progress, bgPointer1, bgPointer2 };
  },
});
</script>

<style scoped>
a {
  color: #2c3e50;
  text-decoration: none;
}

.content {
  height: 300vh;
}

.title-container {
  position: fixed;
  font-size: 100px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.title {
  cursor: pointer;
  transition-duration: 0.5s;
}

.title:hover {
  text-shadow: 3px 3px 0px rgb(60, 103, 255);
  transform: translateY(-5px);
}

.detail-button {
  transform: translate(-50%, 0);
}

.navigation-container {
  position: fixed;
  background: #adb5bd;
  height: 5px;
  width: 100%;
  top: 90%;
}

.navigation-container .progress {
  position: absolute;
  background: #2c3e50;
  height: 5px;
}

.flashing-pointer-container {
  position: absolute;
  display: flex;
  width: 100%;
  height: 5px;
}

.flashing-pointer-1 {
  position: absolute;
  left: calc(100% * 1 / 3);
  aspect-ratio: 1 / 1;
  background: #adb5bd;
  border-radius: 50%;
  /* filter: blur(5px); */
  width: min(100%, 16px);
  transform: translate(-8px, -5.5px);
}

.flashing-pointer-2 {
  position: absolute;
  left: calc(100% * 2 / 3);
  aspect-ratio: 1 / 1;
  background: #adb5bd;
  border-radius: 50%;
  /* filter: blur(5px); */
  width: min(100%, 16px);
  transform: translate(-8px, -5.5px);
}
</style>